<template>
  <div id="coupon-selector" class="slideUp transaction">
    <div class="back-button" @click="$closeModal()">
      <i class="anyteachicon anyteach-prev" />
    </div>
    <br />
    <div class="coupon-selector-null coupon touchable" @click="selectCoupon('')">
      <i
        :class="{ selected: coupon == '' }"
        class="couponSelectedIcon anyteachicon anyteach-check-circle"
      />
      <h2>不使用学习券</h2>
    </div>
    <div class="coupon-selector-coupons">
      <Coupon
        v-for="(value, key) in coupons"
        :key="key"
        :coupon-selected="coupon.id"
        :coupon="value"
        @selectCoupon="selectCoupon($event)"
      />
    </div>
  </div>
</template>

<script>
import Coupon from "../../../public/Coupon"
import { setTimeout } from "timers"
export default {
  name: "CouponSelector",
  components: { Coupon },
  props: ["coupons", "coupon"],
  methods: {
    selectCoupon(coupon) {
      this.$emit("selectCoupon", coupon)
      setTimeout(() => {
        this.$closeModal()
      }, 400)
    },
  },
}
</script>

<style lang="scss">
@import "../../../../../static/css/transaction.scss";
@import "../../../../../static/css/prog-form.scss";
#coupon-selector {
  position: fixed;
  top: 0;
  height: 100vh;
  overflow: scroll;
  width: 100%;
  left: 0;
  padding: 5%;
  z-index: 1;
  background-color: white;
  animation-duration: 0.3s !important;
  animation-timing-function: ease-in-out !important;
  .coupon-selector-null {
    h2 {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  .coupon-selector-coupons {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $lightGrey;
  }
  .back-button {
    font-size: 1rem;
  }
}
</style>
